import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import ChartView from '@/views/Chart.vue'

const routes = [
  {
    path: '/',
    redirect: { name: 'Home' }, // 將 '/' 轉址到 'Home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: 'Home' }
  },
  {
    path: '/Chart/:code',
    name: 'Chart',
    component: ChartView,
    meta: { title: '技術指標' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} | BootstrapVue Next` : 'BootstrapVue Next'
})

export default router